import { createSelector } from 'reselect'
import * as  R from 'ramda'
import {
  globalRoleSelector,
  isLoadedSelector
} from 'containers/Role/Global/selectors'

import {
  projectRoleSelector,
} from 'containers/Role/Project/selectors'

const rolesSelector = createSelector(
  globalRoleSelector,
  projectRoleSelector,
  R.concat
)

export {
  rolesSelector,
  isLoadedSelector,
}
